/*
 * Copyright (c) Worldline 2022.
 */

import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'embedded-link',
    templateUrl: './embedded-link.component.html',
})
export class EmbeddedLinkComponent implements OnInit {

    @Input()
    data!: string;
    @Input()
    action!: Function;
    leftPart: string | null = null
    middlePart: string | null = null
    rightPart: string | null = null
    private A_TAG_REGEX = /(.*)<a .*>(.*?)<\/a>(.*)/g

    ngOnInit(): void {
        const match = this.A_TAG_REGEX.exec(this.data)
        if (match) {
            if (match.length == 4) {
                this.leftPart = match[1]
                this.middlePart = match[2]
                this.rightPart = match[3]
            } else {
                this.leftPart = match[0]
            }
        }
    }

    callAction(event) {
        this.action()
        event.stopPropagation()
        return false
    }
}